import axios from '../config/axios';

export const contactService = {
  submit: async (data) => {
    const response = await axios.post('/contact', data);
    return response.data;
  }
};

export const projectService = {
  getAll: async (params = {}) => {
    const response = await axios.get('/projects', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`/projects/${id}`);
    return response.data;
  }
};
